import { useMemo } from 'react';
import { TOPICS } from '../data/topics';

/**
 * Hook to calculate module completion statistics
 * Based on actual lessons in lessons.json and progress tracker
 */
export function useModuleProgress(progress) {
  // Get all bundled lessons (memoized to prevent dependency changes)
  const allLessons = useMemo(() => {
    try {
      // eslint-disable-next-line
      return require('../data/lessons.json');
    } catch (_) {
      return {};
    }
  }, []);

  return useMemo(() => {
    const moduleStats = {};

    Object.entries(TOPICS).forEach(([topicKey, topic]) => {
      // Count total lessons in this topic
      const topicLessons = Object.keys(allLessons).filter(key => 
        key.startsWith(`${topicKey}::`)
      );

      // Count completed lessons in this topic
      const completedInTopic = progress.completedLessons.filter(key =>
        key.startsWith(`${topicKey}::`)
      ).length;

      // Calculate completion percentage
      const pct = topicLessons.length > 0 
        ? Math.round((completedInTopic / topicLessons.length) * 100)
        : 0;

      // Determine status
      let status = 'normal';
      if (pct === 100 && topicLessons.length > 0) {
        status = 'completed';
      } else if (pct > 0) {
        status = 'active';
      }

      moduleStats[topicKey] = {
        total: topicLessons.length,
        completed: completedInTopic,
        pct,
        status,
        lessons: topicLessons.length,
        hours: (topicLessons.length * 0.3).toFixed(1), // Estimate 18 min per lesson
      };
    });

    return moduleStats;
  }, [progress.completedLessons, allLessons]);
}
